import React from 'react';
import styled from '@emotion/styled';
import { InfoLine, Status } from '../Elements';
import ReferenceMedia from '../ReferenceMedia';
import { Title } from 'app/components/Typography/Title';
import { get } from 'lodash';
import ReferenceFile from '../ReferenceFile';

const Container = styled.div`
  margin-top: 8px;
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  h5 {
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 0px;
  }
`;
const StyledCheckCriteria = styled(InfoLine)`
  .ant-space-item:first-of-type {
    min-width: 90px;
  }
`;
type Props = {
  checkItem: any;
  title: string;
};
const CheckingItem: React.FC<Props> = ({ checkItem, title }) => {
  return (
    <Container>
      <Title level={5}>{title}</Title>
      <StyledCheckCriteria
        align="baseline"
        label="Check Criteria:"
        value={checkItem?.checkCriteria}
      ></StyledCheckCriteria>
      <InfoLine
        label="Result:"
        value={<Status status={checkItem?.result || 'pending'}></Status>}
      ></InfoLine>
      <StyledCheckCriteria
        align="baseline"
        label="Section Remarks:"
        value={checkItem?.remark || 'N/A'}
      ></StyledCheckCriteria>
      <ReferenceMedia
        media={get(checkItem, 'referenceMedia', [])}
      ></ReferenceMedia>
      <ReferenceFile
        files={get(checkItem, 'referenceFile', [])}
      ></ReferenceFile>
    </Container>
  );
};

export default CheckingItem;
